import React, { useEffect, useState } from 'react';
import OtpVerification from 'pages/auth/OtpVerification';
import UserNameCreation from 'pages/auth/UserNameCreation';
import LoginAndSignup from './AuthForm';
import AuthWrapper from './AuthWrapper';
import { Helmet } from 'react-helmet';

const Login = () => {
  const params = new URLSearchParams(window.location.search);
  const type = params.get('type');

  const [compValue, setCompValue] = useState('SignUp');

  useEffect(() => {
    setCompValue(type === 'username' ? 'username' : 'SignUp');
  }, [type]);

  const handleSubmit = (value) => {
    setCompValue(value);
  };

  const handleChangeComponets = (val) => {
    switch (val) {
      case 'username':
        return <UserNameCreation handleChange={(val) => handleSubmit(val)} />;
      case 'verification':
        return <OtpVerification handleChange={(val) => handleSubmit(val)} />;
      default:
        return (
          <LoginAndSignup
            type="SignUp"
            handleChange={() => handleSubmit('verification')}
          />
        );
    }
  };

  return <AuthWrapper>
    <Helmet>
      <title>Sign Up | WafyNet - Create Your Free Account</title>
      <meta
        name="description"
        content="Join WafyNet today! Create your free account to find jobs, grow your network, and discover new business opportunities."
      />
    </Helmet>
    {handleChangeComponets(compValue)}
  </AuthWrapper>;
};

export default Login;
